<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${purchasesInvoice.code}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="purchasesInvoice" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "purchases-invoice-view-logs",

  components: { LogListTable },

  props: ["purchasesInvoice"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
